/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addOfflineIds = /* GraphQL */ `
  mutation AddOfflineIds($quoteId: ID!, $username: String!) {
    addOfflineIds(quoteId: $quoteId, username: $username) {
      status
    }
  }
`
export const removeOfflineIds = /* GraphQL */ `
  mutation RemoveOfflineIds($quoteId: ID!, $username: String!) {
    removeOfflineIds(quoteId: $quoteId, username: $username) {
      status
    }
  }
`
export const addFreelancerToProject = /* GraphQL */ `
  mutation AddFreelancerToProject($projectId: ID!, $freelancerId: ID!) {
    addFreelancerToProject(projectId: $projectId, freelancerId: $freelancerId) {
      status
    }
  }
`
export const removeFreelancerFromProject = /* GraphQL */ `
  mutation RemoveFreelancerFromProject($projectId: ID!, $freelancerId: ID!) {
    removeFreelancerFromProject(projectId: $projectId, freelancerId: $freelancerId) {
      status
    }
  }
`
export const createQuoteInfoCostlines = /* GraphQL */ `
  mutation CreateQuoteInfoCostlines($input: QuoteInfoInputDetails, $quoteType: String!) {
    createQuoteInfoCostlines(input: $input, quoteType: $quoteType) {
      status
    }
  }
`
export const duplicateQuote = /* GraphQL */ `
  mutation DuplicateQuote($quoteId: ID!, $bidLetter: Boolean, $recapTable: Boolean) {
    duplicateQuote(quoteId: $quoteId, bidLetter: $bidLetter, recapTable: $recapTable) {
      status
    }
  }
`
export const moveQuote = /* GraphQL */ `
  mutation MoveQuote($quoteId: ID!, $parentProjectId: ID!) {
    moveQuote(quoteId: $quoteId, parentProjectId: $parentProjectId) {
      status
    }
  }
`
export const refreshRecapQuoteInfo = /* GraphQL */ `
  mutation RefreshRecapQuoteInfo($quoteId: ID!) {
    refreshRecapQuoteInfo(quoteId: $quoteId) {
      status
    }
  }
`
export const updateQuoteMarginsAndOverhead = /* GraphQL */ `
  mutation UpdateQuoteMarginsAndOverhead(
    $quoteId: ID!
    $updateGlobalMargins: Boolean
    $updateGlobalOverheads: Boolean
    $updateGlobalExchangeRate: Boolean
  ) {
    updateQuoteMarginsAndOverhead(
      quoteId: $quoteId
      updateGlobalMargins: $updateGlobalMargins
      updateGlobalOverheads: $updateGlobalOverheads
      updateGlobalExchangeRate: $updateGlobalExchangeRate
    ) {
      status
    }
  }
`
export const calculateMarginsAndTotals = /* GraphQL */ `
  mutation CalculateMarginsAndTotals($quoteId: ID!) {
    calculateMarginsAndTotals(quoteId: $quoteId) {
      status
    }
  }
`
export const deleteClientById = /* GraphQL */ `
  mutation DeleteClientById($clientId: ID!) {
    deleteClientById(clientId: $clientId) {
      status
    }
  }
`
export const deleteProjectById = /* GraphQL */ `
  mutation DeleteProjectById($projectId: ID!) {
    deleteProjectById(projectId: $projectId) {
      status
    }
  }
`
export const deleteQuoteById = /* GraphQL */ `
  mutation DeleteQuoteById($quoteId: ID!) {
    deleteQuoteById(quoteId: $quoteId) {
      status
    }
  }
`;
export const createUniqueEmailId = /* GraphQL */ `
  mutation CreateUniqueEmailId($companyId: ID!, $emailDomain: String!) {
    createUniqueEmailId(companyId: $companyId, emailDomain: $emailDomain) {
      status
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany($input: CreateCompanyInput!, $condition: ModelCompanyConditionInput) {
    createCompany(input: $input, condition: $condition) {
      id
      tenantId
      name
      email
      phone
      website
      registrationNumber
      vatNumber
      addressLine1
      addressLine2
      logoImage {
        bucket
        region
        key
        identityId
      }
      invoiceCount
      purchaseOrderInvoiceCount
      invoicingYear
      bank
      iban
      bic
      accountName
      bankProfileName
      bankProfileName2
      bank2
      iban2
      bic2
      accountName2
      bankProfileName3
      bank3
      iban3
      bic3
      accountName3
      duplicateQuoteCounter
      companyEmailId
      companyInvoices {
        bucket
        region
        key
        identityId
        fileName
        fileType
        fromEmailId
        thumbnailBucket
        thumbnailRegion
        thumbnailKey
        thumbnailIdentityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany($input: UpdateCompanyInput!, $condition: ModelCompanyConditionInput) {
    updateCompany(input: $input, condition: $condition) {
      id
      tenantId
      name
      email
      phone
      website
      registrationNumber
      vatNumber
      addressLine1
      addressLine2
      logoImage {
        bucket
        region
        key
        identityId
      }
      invoiceCount
      purchaseOrderInvoiceCount
      invoicingYear
      bank
      iban
      bic
      accountName
      bankProfileName
      bankProfileName2
      bank2
      iban2
      bic2
      accountName2
      bankProfileName3
      bank3
      iban3
      bic3
      accountName3
      duplicateQuoteCounter
      companyEmailId
      companyInvoices {
        bucket
        region
        key
        identityId
        fileName
        fileType
        fromEmailId
        thumbnailBucket
        thumbnailRegion
        thumbnailKey
        thumbnailIdentityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany($input: DeleteCompanyInput!, $condition: ModelCompanyConditionInput) {
    deleteCompany(input: $input, condition: $condition) {
      id
      tenantId
      name
      email
      phone
      website
      registrationNumber
      vatNumber
      addressLine1
      addressLine2
      logoImage {
        bucket
        region
        key
        identityId
      }
      invoiceCount
      purchaseOrderInvoiceCount
      invoicingYear
      bank
      iban
      bic
      accountName
      bankProfileName
      bankProfileName2
      bank2
      iban2
      bic2
      accountName2
      bankProfileName3
      bank3
      iban3
      bic3
      accountName3
      duplicateQuoteCounter
      companyEmailId
      companyInvoices {
        bucket
        region
        key
        identityId
        fileName
        fileType
        fromEmailId
        thumbnailBucket
        thumbnailRegion
        thumbnailKey
        thumbnailIdentityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo($input: CreateUserInfoInput!, $condition: ModelUserInfoConditionInput) {
    createUserInfo(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      tenantId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
  }
`
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo($input: UpdateUserInfoInput!, $condition: ModelUserInfoConditionInput) {
    updateUserInfo(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      tenantId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
  }
`
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo($input: DeleteUserInfoInput!, $condition: ModelUserInfoConditionInput) {
    deleteUserInfo(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      tenantId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
  }
`
export const createFreelancers = /* GraphQL */ `
  mutation CreateFreelancers(
    $input: CreateFreelancersInput!
    $condition: ModelFreelancersConditionInput
  ) {
    createFreelancers(input: $input, condition: $condition) {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      profileImage {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const updateFreelancers = /* GraphQL */ `
  mutation UpdateFreelancers(
    $input: UpdateFreelancersInput!
    $condition: ModelFreelancersConditionInput
  ) {
    updateFreelancers(input: $input, condition: $condition) {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      profileImage {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const deleteFreelancers = /* GraphQL */ `
  mutation DeleteFreelancers(
    $input: DeleteFreelancersInput!
    $condition: ModelFreelancersConditionInput
  ) {
    deleteFreelancers(input: $input, condition: $condition) {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      profileImage {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const createContact = /* GraphQL */ `
  mutation CreateContact($input: CreateContactInput!, $condition: ModelContactConditionInput) {
    createContact(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      email
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const updateContact = /* GraphQL */ `
  mutation UpdateContact($input: UpdateContactInput!, $condition: ModelContactConditionInput) {
    updateContact(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      email
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact($input: DeleteContactInput!, $condition: ModelContactConditionInput) {
    deleteContact(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      email
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const createSuppliers = /* GraphQL */ `
  mutation CreateSuppliers(
    $input: CreateSuppliersInput!
    $condition: ModelSuppliersConditionInput
  ) {
    createSuppliers(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      contactEmail
      companyEmail
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      commercialName
      supplierCreditorAccount
      supplierType
      individualType
      isArchived
      purchase {
        items {
          id
          tenantId
          activeFlag
          quoteId
          supplierId
          recapCostlineId
          quoteName
          projectName
          supplierName
          recapCostlineItem
          recapCostlineItem_fr
          provisionalTotal
          invoiceTotal
          taxAmount
          purchaseInvoiceDueDate
          purchaseArchivedDate
          purchasePaidDate
          supplierCreditorAccount
          purchaseOrderId
          poAvailable
          invoiceAvailable
          paymentStatus
          purchaseType
          supplierType
          invoiceKey
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const updateSuppliers = /* GraphQL */ `
  mutation UpdateSuppliers(
    $input: UpdateSuppliersInput!
    $condition: ModelSuppliersConditionInput
  ) {
    updateSuppliers(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      contactEmail
      companyEmail
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      commercialName
      supplierCreditorAccount
      supplierType
      individualType
      isArchived
      purchase {
        items {
          id
          tenantId
          activeFlag
          quoteId
          supplierId
          recapCostlineId
          quoteName
          projectName
          supplierName
          recapCostlineItem
          recapCostlineItem_fr
          provisionalTotal
          invoiceTotal
          taxAmount
          purchaseInvoiceDueDate
          purchaseArchivedDate
          purchasePaidDate
          supplierCreditorAccount
          purchaseOrderId
          poAvailable
          invoiceAvailable
          paymentStatus
          purchaseType
          supplierType
          invoiceKey
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const deleteSuppliers = /* GraphQL */ `
  mutation DeleteSuppliers(
    $input: DeleteSuppliersInput!
    $condition: ModelSuppliersConditionInput
  ) {
    deleteSuppliers(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      contactEmail
      companyEmail
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      note
      bank
      iban
      bic
      accountName
      commercialName
      supplierCreditorAccount
      supplierType
      individualType
      isArchived
      purchase {
        items {
          id
          tenantId
          activeFlag
          quoteId
          supplierId
          recapCostlineId
          quoteName
          projectName
          supplierName
          recapCostlineItem
          recapCostlineItem_fr
          provisionalTotal
          invoiceTotal
          taxAmount
          purchaseInvoiceDueDate
          purchaseArchivedDate
          purchasePaidDate
          supplierCreditorAccount
          purchaseOrderId
          poAvailable
          invoiceAvailable
          paymentStatus
          purchaseType
          supplierType
          invoiceKey
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
        }
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const createPurchase = /* GraphQL */ `
  mutation CreatePurchase($input: CreatePurchaseInput!, $condition: ModelPurchaseConditionInput) {
    createPurchase(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const updatePurchase = /* GraphQL */ `
  mutation UpdatePurchase($input: UpdatePurchaseInput!, $condition: ModelPurchaseConditionInput) {
    updatePurchase(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const deletePurchase = /* GraphQL */ `
  mutation DeletePurchase($input: DeletePurchaseInput!, $condition: ModelPurchaseConditionInput) {
    deletePurchase(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const createPurchaseOrder = /* GraphQL */ `
  mutation CreatePurchaseOrder(
    $input: CreatePurchaseOrderInput!
    $condition: ModelPurchaseOrderConditionInput
  ) {
    createPurchaseOrder(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      purchaseOrderNumber
      quoteId
      supplierId
      recapCostlineId
      costlineName
      costlineName_fr
      projectId
      poAvailable
      supplierName
      supplierTerms
      quantity
      number
      rate
      provisionalTotal
      taxRate
      deliveryDate
      deliveryAddress
      comments
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const updatePurchaseOrder = /* GraphQL */ `
  mutation UpdatePurchaseOrder(
    $input: UpdatePurchaseOrderInput!
    $condition: ModelPurchaseOrderConditionInput
  ) {
    updatePurchaseOrder(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      purchaseOrderNumber
      quoteId
      supplierId
      recapCostlineId
      costlineName
      costlineName_fr
      projectId
      poAvailable
      supplierName
      supplierTerms
      quantity
      number
      rate
      provisionalTotal
      taxRate
      deliveryDate
      deliveryAddress
      comments
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const deletePurchaseOrder = /* GraphQL */ `
  mutation DeletePurchaseOrder(
    $input: DeletePurchaseOrderInput!
    $condition: ModelPurchaseOrderConditionInput
  ) {
    deletePurchaseOrder(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      purchaseOrderNumber
      quoteId
      supplierId
      recapCostlineId
      costlineName
      costlineName_fr
      projectId
      poAvailable
      supplierName
      supplierTerms
      quantity
      number
      rate
      provisionalTotal
      taxRate
      deliveryDate
      deliveryAddress
      comments
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
    }
  }
`
export const createClients = /* GraphQL */ `
  mutation CreateClients($input: CreateClientsInput!, $condition: ModelClientsConditionInput) {
    createClients(input: $input, condition: $condition) {
      id
      name
      email
      tenantId
      offlineIds
      activeFlag
      projects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const updateClients = /* GraphQL */ `
  mutation UpdateClients($input: UpdateClientsInput!, $condition: ModelClientsConditionInput) {
    updateClients(input: $input, condition: $condition) {
      id
      name
      email
      tenantId
      offlineIds
      activeFlag
      projects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const deleteClients = /* GraphQL */ `
  mutation DeleteClients($input: DeleteClientsInput!, $condition: ModelClientsConditionInput) {
    deleteClients(input: $input, condition: $condition) {
      id
      name
      email
      tenantId
      offlineIds
      activeFlag
      projects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const createProjects = /* GraphQL */ `
  mutation CreateProjects($input: CreateProjectsInput!, $condition: ModelProjectsConditionInput) {
    createProjects(input: $input, condition: $condition) {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      projectType
      parentCompanyId
      childProjects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      quotes {
        items {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const updateProjects = /* GraphQL */ `
  mutation UpdateProjects($input: UpdateProjectsInput!, $condition: ModelProjectsConditionInput) {
    updateProjects(input: $input, condition: $condition) {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      projectType
      parentCompanyId
      childProjects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      quotes {
        items {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const deleteProjects = /* GraphQL */ `
  mutation DeleteProjects($input: DeleteProjectsInput!, $condition: ModelProjectsConditionInput) {
    deleteProjects(input: $input, condition: $condition) {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      projectType
      parentCompanyId
      childProjects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          projectType
          parentCompanyId
          childProjects {
            nextToken
            startedAt
          }
          quotes {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      quotes {
        items {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const createProposals = /* GraphQL */ `
  mutation CreateProposals(
    $input: CreateProposalsInput!
    $condition: ModelProposalsConditionInput
  ) {
    createProposals(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      quoteId
      clientId
      status
      noofInvoices
      quoteName
      projectName
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      quote {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const updateProposals = /* GraphQL */ `
  mutation UpdateProposals(
    $input: UpdateProposalsInput!
    $condition: ModelProposalsConditionInput
  ) {
    updateProposals(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      quoteId
      clientId
      status
      noofInvoices
      quoteName
      projectName
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      quote {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const deleteProposals = /* GraphQL */ `
  mutation DeleteProposals(
    $input: DeleteProposalsInput!
    $condition: ModelProposalsConditionInput
  ) {
    deleteProposals(input: $input, condition: $condition) {
      id
      tenantId
      activeFlag
      quoteId
      clientId
      status
      noofInvoices
      quoteName
      projectName
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      quote {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        recapInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            uuid
            categoryId
            category
            category_fr
            categoryPrefix
            subCategoryId
            subCategory
            subCategory_fr
            subCategoryPrefix
            subCategorySuffix
            tableRowIndex
            item
            item_fr
            isInternational
            editable
            costLineType
            costLineLabel
            language
            number
            rate
            exchangeEnabled
            exchangeRate
            rateInEuros
            quantity
            total
            totalMargin
            payrollTaxEnabled
            payrollTaxType
            isCustomCostLine
            referenceCostLineUuid
            provisionalTotal
            provisionalPayrollTaxEnabled
            provisionalPayrollTaxType
            actualTotal
            actualPayrollTaxEnabled
            actualPayrollTaxType
            purchaseTotal
            supplierStatus
            supplierId
            paymentStatus
            purchaseId
            comments
            invoiceId
            invoiceAvailable
            poAvailable
            purchaseOrderId
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        quoteInfo {
          items {
            id
            quoteId
            tenantId
            freelancers
            childFreelancers
            offlineIds
            activeFlag
            agentCommission
            agentCommissionPercentage
            allowMarginAndOverheadPercentageGlobalUpdate
            language
            category
            categoryId
            categoryPrefix
            category_fr
            costLineLabel
            costLineType
            editable
            exchangeEnabled
            exchangeRate
            tableRowIndex
            isInternational
            isVisible
            item
            item_fr
            margin
            marginPercentage
            number
            overhead
            overheadPercentage
            overtimeHours
            overtimeHoursCost
            payrollTaxEnabled
            payrollTaxType
            quantity
            rate
            rateInEuros
            subCategory
            subCategoryId
            subCategoryPrefix
            subCategorySuffix
            subCategory_fr
            total
            totalHeading
            totalMargin
            unit
            smg
            _version
            _deleted
            _lastChangedAt
            createdAt
            updatedAt
          }
          nextToken
          startedAt
        }
        proposals {
          items {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          projectName
          clientId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          proposalsDraft {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          proposals {
            id
            tenantId
            activeFlag
            quoteId
            clientId
            status
            noofInvoices
            quoteName
            projectName
            clientTaxType
            clientName
            contactName
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            paymentTerms
            total
            clientNote
            isDetailed
            bankProfileNumber
            proposalsBankProfileName
            proposalsBank
            proposalsIban
            proposalsBic
            proposalsAccountName
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const createInvoices = /* GraphQL */ `
  mutation CreateInvoices($input: CreateInvoicesInput!, $condition: ModelInvoicesConditionInput) {
    createInvoices(input: $input, condition: $condition) {
      id
      tenantId
      proposalId
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      projectName
      clientId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const updateInvoices = /* GraphQL */ `
  mutation UpdateInvoices($input: UpdateInvoicesInput!, $condition: ModelInvoicesConditionInput) {
    updateInvoices(input: $input, condition: $condition) {
      id
      tenantId
      proposalId
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      projectName
      clientId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const deleteInvoices = /* GraphQL */ `
  mutation DeleteInvoices($input: DeleteInvoicesInput!, $condition: ModelInvoicesConditionInput) {
    deleteInvoices(input: $input, condition: $condition) {
      id
      tenantId
      proposalId
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      projectName
      clientId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        clientId
        status
        noofInvoices
        quoteName
        projectName
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
        }
        quote {
          id
          name
          tenantId
          quoteType
          childFreelancers
          offlineIds
          activeFlag
          type
          parentProjectId
          billLocation
          marginPercentage
          overheadPercentage
          exchangeRate
          allowInternational
          freelancers
          parentCompanyId
          maximizeMinimize
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          recapInfoComments
          contact
          discount {
            totalDiscount
            totalAfterDiscount
            totalDiscountOnMargin
            totalDiscountOnMarginPercentage
            totalDiscountPercentage
          }
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          recapInfo {
            nextToken
            startedAt
          }
          quoteInfo {
            nextToken
            startedAt
          }
          proposals {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        invoices {
          items {
            id
            tenantId
            proposalId
            activeFlag
            originalInvoiceId
            creditInvoiceGenerated
            archivedDate
            paidDate
            paymentStatus
            quoteName
            projectName
            clientId
            clientName
            contactName
            clientTaxType
            clientEmail
            clientAddress
            clientIdNumber
            clientVatNumber
            clientCurrency
            clientTaxRate
            title
            invoiceNumber
            poNumber
            invoiceAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            clientNote
            isDetailed
            bankProfileNumber
            invoicesBankProfileName
            invoicesBank
            invoicesIban
            invoicesBic
            invoicesAccountName
            invoiceDate
            invoiceDueDate
            description
            creditComments
            invoiceType
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          nextToken
          startedAt
        }
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const createQuote = /* GraphQL */ `
  mutation CreateQuote($input: CreateQuoteInput!, $condition: ModelQuoteConditionInput) {
    createQuote(input: $input, condition: $condition) {
      id
      name
      tenantId
      quoteType
      childFreelancers
      offlineIds
      activeFlag
      type
      parentProjectId
      billLocation
      marginPercentage
      overheadPercentage
      exchangeRate
      allowInternational
      freelancers
      parentCompanyId
      maximizeMinimize
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      recapInfoComments
      contact
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      recapInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          uuid
          categoryId
          category
          category_fr
          categoryPrefix
          subCategoryId
          subCategory
          subCategory_fr
          subCategoryPrefix
          subCategorySuffix
          tableRowIndex
          item
          item_fr
          isInternational
          editable
          costLineType
          costLineLabel
          language
          number
          rate
          exchangeEnabled
          exchangeRate
          rateInEuros
          quantity
          total
          totalMargin
          payrollTaxEnabled
          payrollTaxType
          isCustomCostLine
          referenceCostLineUuid
          provisionalTotal
          provisionalPayrollTaxEnabled
          provisionalPayrollTaxType
          actualTotal
          actualPayrollTaxEnabled
          actualPayrollTaxType
          purchaseTotal
          supplierStatus
          supplierId
          paymentStatus
          purchaseId
          comments
          invoiceId
          invoiceAvailable
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          poAvailable
          purchaseOrderId
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      quoteInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          agentCommission
          agentCommissionPercentage
          allowMarginAndOverheadPercentageGlobalUpdate
          language
          category
          categoryId
          categoryPrefix
          category_fr
          costLineLabel
          costLineType
          editable
          exchangeEnabled
          exchangeRate
          tableRowIndex
          isInternational
          isVisible
          item
          item_fr
          margin
          marginPercentage
          number
          overhead
          overheadPercentage
          overtimeDetails {
            multiplier
            overtimeHours
          }
          overtimeHours
          overtimeHoursCost
          payrollTaxEnabled
          payrollTaxType
          quantity
          rate
          rateInEuros
          subCategory
          subCategoryId
          subCategoryPrefix
          subCategorySuffix
          subCategory_fr
          total
          totalHeading
          totalMargin
          unit
          smg
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const updateQuote = /* GraphQL */ `
  mutation UpdateQuote($input: UpdateQuoteInput!, $condition: ModelQuoteConditionInput) {
    updateQuote(input: $input, condition: $condition) {
      id
      name
      tenantId
      quoteType
      childFreelancers
      offlineIds
      activeFlag
      type
      parentProjectId
      billLocation
      marginPercentage
      overheadPercentage
      exchangeRate
      allowInternational
      freelancers
      parentCompanyId
      maximizeMinimize
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      recapInfoComments
      contact
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      recapInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          uuid
          categoryId
          category
          category_fr
          categoryPrefix
          subCategoryId
          subCategory
          subCategory_fr
          subCategoryPrefix
          subCategorySuffix
          tableRowIndex
          item
          item_fr
          isInternational
          editable
          costLineType
          costLineLabel
          language
          number
          rate
          exchangeEnabled
          exchangeRate
          rateInEuros
          quantity
          total
          totalMargin
          payrollTaxEnabled
          payrollTaxType
          isCustomCostLine
          referenceCostLineUuid
          provisionalTotal
          provisionalPayrollTaxEnabled
          provisionalPayrollTaxType
          actualTotal
          actualPayrollTaxEnabled
          actualPayrollTaxType
          purchaseTotal
          supplierStatus
          supplierId
          paymentStatus
          purchaseId
          comments
          invoiceId
          invoiceAvailable
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          poAvailable
          purchaseOrderId
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      quoteInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          agentCommission
          agentCommissionPercentage
          allowMarginAndOverheadPercentageGlobalUpdate
          language
          category
          categoryId
          categoryPrefix
          category_fr
          costLineLabel
          costLineType
          editable
          exchangeEnabled
          exchangeRate
          tableRowIndex
          isInternational
          isVisible
          item
          item_fr
          margin
          marginPercentage
          number
          overhead
          overheadPercentage
          overtimeDetails {
            multiplier
            overtimeHours
          }
          overtimeHours
          overtimeHoursCost
          payrollTaxEnabled
          payrollTaxType
          quantity
          rate
          rateInEuros
          subCategory
          subCategoryId
          subCategoryPrefix
          subCategorySuffix
          subCategory_fr
          total
          totalHeading
          totalMargin
          unit
          smg
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const deleteQuote = /* GraphQL */ `
  mutation DeleteQuote($input: DeleteQuoteInput!, $condition: ModelQuoteConditionInput) {
    deleteQuote(input: $input, condition: $condition) {
      id
      name
      tenantId
      quoteType
      childFreelancers
      offlineIds
      activeFlag
      type
      parentProjectId
      billLocation
      marginPercentage
      overheadPercentage
      exchangeRate
      allowInternational
      freelancers
      parentCompanyId
      maximizeMinimize
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      recapInfoComments
      contact
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      recapInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          uuid
          categoryId
          category
          category_fr
          categoryPrefix
          subCategoryId
          subCategory
          subCategory_fr
          subCategoryPrefix
          subCategorySuffix
          tableRowIndex
          item
          item_fr
          isInternational
          editable
          costLineType
          costLineLabel
          language
          number
          rate
          exchangeEnabled
          exchangeRate
          rateInEuros
          quantity
          total
          totalMargin
          payrollTaxEnabled
          payrollTaxType
          isCustomCostLine
          referenceCostLineUuid
          provisionalTotal
          provisionalPayrollTaxEnabled
          provisionalPayrollTaxType
          actualTotal
          actualPayrollTaxEnabled
          actualPayrollTaxType
          purchaseTotal
          supplierStatus
          supplierId
          paymentStatus
          purchaseId
          comments
          invoiceId
          invoiceAvailable
          invoiceDocuments {
            bucket
            region
            key
            identityId
          }
          poAvailable
          purchaseOrderId
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      quoteInfo {
        items {
          id
          quoteId
          tenantId
          freelancers
          childFreelancers
          offlineIds
          activeFlag
          agentCommission
          agentCommissionPercentage
          allowMarginAndOverheadPercentageGlobalUpdate
          language
          category
          categoryId
          categoryPrefix
          category_fr
          costLineLabel
          costLineType
          editable
          exchangeEnabled
          exchangeRate
          tableRowIndex
          isInternational
          isVisible
          item
          item_fr
          margin
          marginPercentage
          number
          overhead
          overheadPercentage
          overtimeDetails {
            multiplier
            overtimeHours
          }
          overtimeHours
          overtimeHoursCost
          payrollTaxEnabled
          payrollTaxType
          quantity
          rate
          rateInEuros
          subCategory
          subCategoryId
          subCategoryPrefix
          subCategorySuffix
          subCategory_fr
          total
          totalHeading
          totalMargin
          unit
          smg
          _version
          _deleted
          _lastChangedAt
          createdAt
          updatedAt
        }
        nextToken
        startedAt
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          clientId
          status
          noofInvoices
          quoteName
          projectName
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          drafts {
            generated
            poNumber
            proposalAmountPercentage
            amount
            amountAfterTax
            taxAmount
            balancePercentage
            balanceAmount
            invoiceId
            invoiceDate
            invoiceDueDate
            description
            readyStatus
          }
          quote {
            id
            name
            tenantId
            quoteType
            childFreelancers
            offlineIds
            activeFlag
            type
            parentProjectId
            billLocation
            marginPercentage
            overheadPercentage
            exchangeRate
            allowInternational
            freelancers
            parentCompanyId
            maximizeMinimize
            clientName
            projectName
            agency
            agencyRepresentative
            director
            executiveProducer
            lineProducer
            numberOfShootingDays
            notes
            introduction
            shooting
            prep
            shootingCountry
            prelight
            casting
            crew
            buyouts
            locations
            studio
            artDepartment
            wardrobe
            equipment
            travel
            accommodation
            editing
            imagePostproduction
            soundPostproduction
            deliverables
            insurance
            quoteGuidelines
            excluded
            paymentTerms
            miscellaneous
            installment1Percentage
            installment1Date
            installment2Percentage
            installment2Date
            balancePercentage
            balanceDate
            isStarred
            isChecked
            recapInfoComments
            contact
            advertiserJobID
            brand
            jobName
            agencyJobID
            product
            advertiser
            productionJobID
            advertiserAddress
            productionCompany
            productionContact
            vfxCo
            vfxProducer
            editorialCo
            editorialProducer
            musicCo
            musicProducer
            agencyProducer
            agencyCreativeTeam
            prepDays
            buildAndStrikeDays
            preLight
            stageDays
            locationDays
            createdOn
            updatedOn
            _version
            _deleted
            _lastChangedAt
          }
          invoices {
            nextToken
            startedAt
          }
          createdOn
          updatedOn
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdOn
      updatedOn
      _version
      _deleted
      _lastChangedAt
    }
  }
`
export const createQuoteInfo = /* GraphQL */ `
  mutation CreateQuoteInfo(
    $input: CreateQuoteInfoInput!
    $condition: ModelQuoteInfoConditionInput
  ) {
    createQuoteInfo(input: $input, condition: $condition) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      category
      categoryId
      categoryPrefix
      category_fr
      costLineLabel
      costLineType
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      overhead
      overheadPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      total
      totalHeading
      totalMargin
      unit
      smg
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const updateQuoteInfo = /* GraphQL */ `
  mutation UpdateQuoteInfo(
    $input: UpdateQuoteInfoInput!
    $condition: ModelQuoteInfoConditionInput
  ) {
    updateQuoteInfo(input: $input, condition: $condition) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      category
      categoryId
      categoryPrefix
      category_fr
      costLineLabel
      costLineType
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      overhead
      overheadPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      total
      totalHeading
      totalMargin
      unit
      smg
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const deleteQuoteInfo = /* GraphQL */ `
  mutation DeleteQuoteInfo(
    $input: DeleteQuoteInfoInput!
    $condition: ModelQuoteInfoConditionInput
  ) {
    deleteQuoteInfo(input: $input, condition: $condition) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      category
      categoryId
      categoryPrefix
      category_fr
      costLineLabel
      costLineType
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      overhead
      overheadPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      total
      totalHeading
      totalMargin
      unit
      smg
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const createRecapInfo = /* GraphQL */ `
  mutation CreateRecapInfo(
    $input: CreateRecapInfoInput!
    $condition: ModelRecapInfoConditionInput
  ) {
    createRecapInfo(input: $input, condition: $condition) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      categoryId
      category
      category_fr
      categoryPrefix
      subCategoryId
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      tableRowIndex
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      language
      number
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      isCustomCostLine
      referenceCostLineUuid
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const updateRecapInfo = /* GraphQL */ `
  mutation UpdateRecapInfo(
    $input: UpdateRecapInfoInput!
    $condition: ModelRecapInfoConditionInput
  ) {
    updateRecapInfo(input: $input, condition: $condition) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      categoryId
      category
      category_fr
      categoryPrefix
      subCategoryId
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      tableRowIndex
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      language
      number
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      isCustomCostLine
      referenceCostLineUuid
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
export const deleteRecapInfo = /* GraphQL */ `
  mutation DeleteRecapInfo(
    $input: DeleteRecapInfoInput!
    $condition: ModelRecapInfoConditionInput
  ) {
    deleteRecapInfo(input: $input, condition: $condition) {
      id
      quoteId
      tenantId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      categoryId
      category
      category_fr
      categoryPrefix
      subCategoryId
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      tableRowIndex
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      language
      number
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      isCustomCostLine
      referenceCostLineUuid
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`
